export default class ExtensionInfoItemCreateModel {
  extensionInfoId: string = ''
  details: string = ''
  order: number = 0

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data)
    }
  }
}
